import React from 'react'
import {
  Control,
  Controller,
  ControllerRenderProps,
  FieldError,
  RegisterOptions,
} from 'react-hook-form'
import { isArray } from 'lodash'
import { HourSeriesSelect, HourSeriesSelectProps } from './HourSeriesSelect'

type Props = Omit<HourSeriesSelectProps, 'value' | 'onChange' | 'error'> & {
  control: Control
  name: string
  defaultValue?: string[] | string | null
  rules?: RegisterOptions
  error?: FieldError
  single?: boolean
}

export function ControlledHourSeriesSelect(props: Props): React.ReactElement {
  const { control, name, defaultValue, rules, error, single, ...selectProps } =
    props

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? (single ? null : [])}
      rules={rules}
      render={({
        value,
        onChange,
      }: Omit<ControllerRenderProps, 'value'> & {
        value: string[] | string | null | undefined
      }) => (
        <HourSeriesSelect
          {...selectProps}
          name={name}
          value={(isArray(value) ? value[0] : value) ?? null}
          onChange={(newValue) => {
            if (single) {
              onChange(newValue)
              return
            }

            if (newValue === null) {
              onChange([])
              return
            }

            onChange([newValue])
          }}
          error={error?.message}
        />
      )}
    />
  )
}
